import { noop } from 'lodash';
import { createContext } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';
import { NewlyCreated } from '@/modules/common/AddNewAnythingModal/AddNewAnythingModal';

export interface DPFormRecipientTrackerContext {
  /**
   * Add a new recipient to the tracked list
   */
  handleNewlyAddedRecipient: (recipient: NewlyCreated) => void;

  /**
   * Whether the user has added a new Testamentary Entity recipient
   * during the current edit session
   */
  hasAddedNewTERecipients: boolean;

  /**
   * Display names of newly added Testamentary Entity recipients
   */
  newlyAddedTERecipientDisplayNames: string[];

  /**
   * Intercepts the onClose of the outer modal, to check if we need to show
   * the confirmation modal for navigating to manage DP. Accepts callbacks
   * to close the outer modal and to confirm navigating to manage DP.
   */
  handleRequestCloseOuterModal: (
    closeOuterModal?: () => void,
    confirmNavigateManageDP?: () => void
  ) => void;

  /**
   * Whether the confirmation modal for navigating to manage DP is open
   */
  isConfirmNavManageDPModalOpen: boolean;

  /**
   * Handles closing the confirmation modal for navigating to manage DP
   */
  handleCloseConfirmNavManageDPModal: (reason: 'confirm' | 'cancel') => void;
}

export const DPFormRecipientTrackerContext =
  createContext<DPFormRecipientTrackerContext>({
    handleNewlyAddedRecipient: noop,
    hasAddedNewTERecipients: false,
    newlyAddedTERecipientDisplayNames: [],
    handleRequestCloseOuterModal: noop,
    isConfirmNavManageDPModalOpen: false,
    handleCloseConfirmNavManageDPModal: noop,
  });

export const useDPFormRecipientTrackerContext = () =>
  useGuardedContext(
    DPFormRecipientTrackerContext,
    'DPFormRecipientTrackerContext'
  );
